import { Component } from 'react';

export default class ErrorBoundary extends Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          display: 'flex', flexDirection: 'column', alignItems: 'center',
          justifyContent: 'center', minHeight: '100vh', color: '#FFD200',
          backgroundColor: '#000', fontFamily: 'Raleway, sans-serif', gap: '1rem'
        }}>
          <p style={{ fontSize: '1.2rem', opacity: 0.8 }}>Something went wrong loading this page.</p>
          <a href="/" style={{ color: '#FFD200', fontSize: '0.95rem' }}>← Go home</a>
        </div>
      );
    }
    return this.props.children;
  }
}
